export enum AdminAddActivityTemplateFormItemLabel {
  Name = "Naziv aktivnosti",
  DaysDelay = "Odmak u danima od prethodne aktivnosti",
  RecommendedChannels = "Predloženi kanali",
}
